<script lang="ts">
    import { _ } from "svelte-i18n"
    import CheckoutHeader from "./checkout/CheckoutHeader.svelte"
    import Shipping from "./checkout/Shipping.svelte"
    import Payment from "./checkout/Payment.svelte"
    import Overview from "./checkout/Overview.svelte"
    import Confirmation from "./checkout/Confirmation.svelte"

    import DealerOverview from "./checkout/DealerOverview.svelte"

    import Index from "../SEO/Index.svelte"
    import { overlay } from "../../store"
    import { location } from "../../i18n"
    import { initialLocale } from "../../i18n"

    let innerWidth = $state(0)
    let containerWidth = $state(0)

    let marginRight = $derived(
        innerWidth > 1024 && $overlay.show
            ? innerWidth * (innerWidth > 1300 ? 0.3 : 0.5) + 20 - (innerWidth - containerWidth) / 2
            : 0
    )
</script>

<Index noIndex={true} title={$_("checkout.checkout")} metaDescription={$_("meta.description")} />

<svelte:window bind:innerWidth />

<section class="section-type-1 section_padding checkout">
    <div class="container" bind:clientWidth={containerWidth}>
        <div class="inner" style="margin-right:{marginRight}px">
            {#if $location.path.startsWith(`/${initialLocale}/checkout/confirmation`)}
                <Confirmation />
            {:else if $location.path.startsWith(`/${initialLocale}/checkout/dealer`)}
                <CheckoutHeader />
                <DealerOverview />
            {:else if $location.path.startsWith(`/${initialLocale}/checkout/overview`)}
                <CheckoutHeader />
                <Overview />
            {:else if $location.path.startsWith(`/${initialLocale}/checkout/payment`)}
                <CheckoutHeader />
                <Payment />
            {:else if $location.path.startsWith(`/${initialLocale}/checkout`)}
                <CheckoutHeader />
                <Shipping />
            {/if}
        </div>
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .inner {
        transition: all 0.3s;
    }
    .checkout :global {
        section {
            margin-bottom: 40px;
            .section_headline {
                font-size: 1.2rem;
                margin-bottom: 15px;
            }
            input,
            textarea,
            select {
                margin-bottom: 0px;
            }
            input:disabled {
                background: var(--comp--input--disabled--background);
                color: var(--comp--input--disabled--color);
            }
        }

        .inputholder input[type="checkbox"]:checked ~ label:before {
            background: var(--primary) !important;
        }
        .inputholder label:before {
            border-color: var(--primary) !important;
        }
        .inputholder input[type="radio"]:checked ~ label:after {
            background: var(--primary) !important;
        }
        .checkout_bottom {
            .flex();
            justify-content: space-between;
            align-items: center;
            .linkback {
                .flex();
                align-items: center;
                .icon {
                    .flex();
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
